__turbopack_context__.v({
  "article": "zYarJW_article",
  "article__meta": "zYarJW_article__meta",
  "articles": "zYarJW_articles",
  "header": "zYarJW_header",
  "list": "zYarJW_list",
  "viewall": "zYarJW_viewall",
  "wrapper": "zYarJW_wrapper",
});
